import { render, staticRenderFns } from "./Hotel.vue?vue&type=template&id=2b329c56&scoped=true&"
import script from "./Hotel.vue?vue&type=script&lang=js&"
export * from "./Hotel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b329c56",
  null
  
)

export default component.exports